import { Box, Checkbox, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import type BulkEditForm from 'modules/employees/pages/EditInBulk/forms/BulkEdit'
import permissionGroups from 'modules/permissions/store/collections/permissionGroups'

interface Props {
  bulkEditForm: BulkEditForm
  isChecked: boolean
  onChange: () => void
  onClick: () => void
  width: number
}

const PermissionGroupCell = ({ bulkEditForm, isChecked, onChange, onClick, width }: Props) => {
  const handleChangePermissionGroup = (id: unknown) => {
    bulkEditForm.setValues({
      permission_group_id: id,
    })
    onChange()
  }

  const permissionGroupOptions = permissionGroups.models.map((permissionGroup) => {
    return (
      <Selector.Option
        key={permissionGroup.id}
        value={permissionGroup.id}
        label={permissionGroup.title}
        searchValue={permissionGroup.title}
        isChecked={isChecked}
      >
        <Box width="full" overflowY="hidden">
          <Text.Normal size="200" weight="medium" ellipsis>
            {permissionGroup.title}
          </Text.Normal>
        </Box>
      </Selector.Option>
    )
  })

  const remainingWidth = width - 78

  return (
    <Box>
      <Box
        background="grey000White"
        flexDirection="row"
        justifyContent="spaceBetween"
        alignItems="center"
        height="full"
        paddingX="s16"
        paddingY="s12"
        border={{
          all: {
            width: 's2',
            style: 'solid',
            color: 'grey000White',
          },
        }}
        gap="s16"
        style={{ width: `${width}px` }}
      >
        <Box flexDirection="row" alignItems="center" gap="s16" width="full">
          <Box flexNoShrink>
            <Checkbox checked={isChecked} onChange={onClick} />
          </Box>
          <Box style={{ width: `${remainingWidth}px` }}>
            <Selector.Popover
              blankLabel={i18n.t('common.empty')}
              allSelectedLabel={i18n.t('common.all')}
              placeholder={i18n.t('common.select')}
              searchPlaceholder={i18n.t('common.search')}
              value={
                +bulkEditForm.get('permission_group_id').value
                  ? [+bulkEditForm.get('permission_group_id').value]
                  : []
              }
              onChange={handleChangePermissionGroup}
            >
              {permissionGroupOptions}
            </Selector.Popover>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(PermissionGroupCell)
